import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import "./section.scss";

export default class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="section section-applicator"
          data-image-src=""
          id="applicator"
        >
          <div className="bg-applicator applicator-half">
            <div className="display-table">
              <div className="display-table-cell">
                <Container>
                  <Row className="justify-content-center">
                    <Col md={12} lg={6} className="section-applicator-description text-white">
                      <h1 className="applicator-title">
                        Aplicador
                      </h1>
                    </Col>
                    <Col className="content-height" md={12} lg={6}></Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
